import { Component, EventEmitter, inject, Input, Output } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { EAddressUsageType } from 'projects/shared/lib/enum/address/address-usage-type.enum';
import { AddressDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { ToastItem } from '../../toast/item/toast-item.model';
import { EToastItemType } from 'projects/shared/lib/enum/toast/toast-entry-type.enum';
import { AddressDetailComponent } from '../detail/address-detail.component';
import { IAddressService, IAddressServiceToken } from 'projects/shared/lib/services/data/address/address-service.interface';
import { IToastService, IToastServiceToken } from 'shared/services/ui/toast/toast-service.interface';

@Component({
  selector: 'app-address-select-dialog',
  imports: [
    FormsModule,
    AddressDetailComponent
  ],
  templateUrl: './address-select-dialog.component.html',
  styleUrls: ['./address-select-dialog.component.scss']
})
export class AddressSelectDialogComponent {
  @Input() modalTitle?: string;
  @Input() addressList?: AddressDto[];
  @Input() knownAddressUsageTypeEnum?: EAddressUsageType;
  @Output() modalSubmit: EventEmitter<AddressDto> = new EventEmitter<AddressDto>();
  @Output() modalCancel: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  private addressService: IAddressService;
  private readonly toastService: IToastService = inject(IToastServiceToken);
  public selectedAddress?: AddressDto;
  public isAddressSelected: boolean;

  public constructor() {
    this.addressService = inject(IAddressServiceToken);
    this.isAddressSelected = false;
  }

  submit(event: MouseEvent) {
    if (this.selectedAddress != undefined) {
      this.modalSubmit.emit(this.selectedAddress);
    }
  }

  cancel(event: MouseEvent) {
    this.modalCancel.emit(event);
  }

  public select(index: number, address: AddressDto) {
    this.selectedAddress = address;
    this.isAddressSelected = true;
  }

  adressDeleteItem(address: AddressDto) {
    this.addressService.addressDelete(address).subscribe(b => {
      if (b) {
        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Success,
          title: $localize`:@@AddressSelectDialogAddressDeleteInfoSuccessTitle:Success`,
          message: $localize`:@@AddressSelectDialogAddressDeleteInfoSuccessMessage:The Adress has been deleted.`,
        }));
        this.addressList = this.addressList?.filter(item => item !== address);
        if (this.addressList != undefined && this.addressList.length > 0) {
          this.selectedAddress = this.addressList[0];
        }
      }
    }, (ex) => {
      this.toastService.toastItemAdd(new ToastItem({
        type: EToastItemType.Danger,
        title: $localize`:@@AddressSelectDialogAddressDeleteInfoErrorTitle:Failure`,
        message: $localize`:@@AddressSelectDialogAddressDeleteInfoErrorMessage:The Adress couldn't be deleted, please try again.`,
        code: JSON.parse(ex.response).errorCode
      }));
    });
  }
}
